import { Component, EventEmitter, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-action-popup',
  templateUrl: './action-popup.component.html',
  styleUrls: ['./action-popup.component.scss'],
})
export class ActionPopupComponent {
  @Output() closeCallback: EventEmitter<any> = new EventEmitter();

  public title: string;
  public closeBtnName: string;
  public cancelBtnText: string;
  public actionBtnText: string;
  public actionValue: string;
  public header: string;
  public text: string;
  public icon: string;
  public isLargeButton: boolean;

  constructor(public bsModalRef: BsModalRef) {}

  // ToDo: Will be needed for other use cases, welcome
  /**
   * on popup hide
   */
  // onHide(): void {
  //   if (this.closeCallback.observers.length) {
  //     this.closeCallback.emit();
  //   }
  // }

  onAction(actionValue = 'no'): void {
    this.bsModalRef.content.callback(actionValue);
    this.bsModalRef.hide();
  }
}
